import { logger } from "../../core/logging/logger";
import { Observable } from "../../utils/observable";
import type { SavingContract, SavingDetails } from "./savings";
import type { SavingsService } from "./savings-service";

export class SavingsManager {
  public savingDetails = new Observable<SavingDetails>({} as SavingDetails);
  public taxStatements = new Observable<any>({});
  public allSavingsProduct = new Observable<any>({});
  public error = new Observable<Error | null>(null);
  public loading = new Observable<boolean>(true);

  public constructor(private savingsService: SavingsService) {}

  public async getSavingsDetails(accountId) {
    try {
      this.loading.set(true);
      this.error.set(null);
      const details = await this.savingsService.getSavingsDetails(accountId);
      this.loading.set(false);
      this.savingDetails.set(details);
    } catch (e) {
      logger.debug("Savings Manager", "Failed to get Savings details", e);
      this.error.set(e);
      this.loading.set(false);
      throw e;
    }
  }

  public async getTaxStatements(accountId) {
    try {
      this.loading.set(true);
      this.error.set(null);
      const statements = await this.savingsService.getTaxStatements(accountId);
      this.loading.set(false);
      this.taxStatements.set(statements);
    } catch (e) {
      logger.debug("Savings Manager", "Failed to get tax statements", e);
      this.error.set(e);
      this.loading.set(false);
      throw e;
    }
  }

  public async getAllSavingsProduct(limit?: string) {
    try {
      this.loading.set(true);
      this.error.set(null);
      const allSavings = await this.savingsService.getAllSavingsProduct(limit);
      this.loading.set(false);
      this.allSavingsProduct.set(allSavings);
    } catch (e) {
      logger.debug("Savings Manager", "Failed to get all Savings product details", e);
      this.error.set(e);
      this.loading.set(false);
      throw e;
    }
  }

  public async createSavingsContract(contract: SavingContract) {
    return await this.savingsService.createSavingsContract(contract);
  }
}
